export const selectBox = state => state.views.shippingCalculator.box;

export const selectFilterValue = filterName => state =>
    state.views.shippingCalculator.box[filterName];

export const selectIsBoxValid = state =>
    state.views.shippingCalculator.box.height &&
    state.views.shippingCalculator.box.length &&
    state.views.shippingCalculator.box.width &&
    state.views.shippingCalculator.box.weight;

export const selectWeightUnit = state =>
    state.views.shippingCalculator.weightUnit;

export const selectWeightSliderValue = state =>
    state.views.shippingCalculator.weightSliderValue;

export const selectNormalizedWeight = state =>
    state.views.shippingCalculator.box.weight % 1000 === 0
        ? state.views.shippingCalculator.box.weight / 1000
        : state.views.shippingCalculator.box.weight;

export const selectWeightString = state =>
    `${selectNormalizedWeight(state)} ${selectWeightUnit(state)}`;

export const isLoadingShippingProducts = state =>
    state.views.shippingCalculator.isLoadingShippingProducts;

export const selectShippingProviders = state =>
    state.views.shippingCalculator.shippingProviders.map(provider => ({
        ...provider,
        domesticProducts:
            selectShippingProducts(state)[
                state.views.shippingCalculator.selectedFromCountry
            ]?.filter(
                ({ shippingProvider }) =>
                    shippingProvider === provider.providerName
            ) || []
    }));

export const selectAvailableShippingProviders = state => {
    const shippingProviders = state.views.shippingCalculator.shippingProviders;
    const shippingProducts = selectShippingProducts(state);

    const includedProviders = [];

    shippingProviders.forEach(provider => {
        Object.keys(shippingProducts).forEach(key => {
            if (
                shippingProducts[key] &&
                shippingProducts[key].length > 0 &&
                shippingProducts[key].some(
                    x =>
                        x.shippingProvider === provider.providerName &&
                        !includedProviders.includes(x.shippingProvider)
                )
            ) {
                includedProviders.push(provider.providerName);
            }
        });
    });

    return shippingProviders.filter(({ providerName }) =>
        includedProviders.find(p => p === providerName)
    );
};

export const selectShippingProducts = state => {
    const {
        internationalProductsGroupedByFromThenToCountry,
        selectedFromCountry
    } = state.views.shippingCalculator;
    return (
        internationalProductsGroupedByFromThenToCountry[selectedFromCountry] ||
        {}
    );
};

export const selectIsDifferentFromDefaultBox = state =>
    !(
        state.views.shippingCalculator.box.length ===
            state.views.shippingCalculator.defaultBox.length &&
        state.views.shippingCalculator.box.width ===
            state.views.shippingCalculator.defaultBox.width &&
        state.views.shippingCalculator.box.height ===
            state.views.shippingCalculator.defaultBox.height &&
        state.views.shippingCalculator.box.weight ===
            state.views.shippingCalculator.defaultBox.weight
    );

export const selectSelectedCountries = state => ({
    selectedFromCountry: state.views.shippingCalculator.selectedFromCountry,
    selectedToCountry: state.views.shippingCalculator.selectedToCountry
});

export const selectAvailableCountryCodes = state => ({
    availableFromCountryCodes:
        state.views.shippingCalculator.availableFromCountryCodes,
    availableToCountryCodes:
        state.views.shippingCalculator.availableToCountryCodes
});

export const selectShowError = state =>
    state.views.shippingCalculator.showError;
